import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Alert from './components/alert'

Vue.use(Alert)
import {post, fetch, patch, put, setCookie, getCookie, removeCookie} from './network/http.js'

//定义全局变量

Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

Vue.prototype.$setCookie = setCookie;
Vue.prototype.$getCookie = getCookie;
Vue.prototype.$removeCookie = removeCookie
Vue.config.productionTip = false;

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   	ak: 'http://api.map.baidu.com/api?v=2.0&ak=yPBKlxTTlv7kMFCmKyYvd0wzywwNyXTZ'
// })
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
